import { useEffect, useRef } from "react";
import { CarCard } from "@/components/cars/CarCard";
import type { CarCardData } from "@/lib/api";

/**
 * Editorial descriptions are narrowly scoped to this new family. The reviewed
 * shared US homepage card remains byte-for-byte unchanged; no name, price,
 * source identity, photograph, entitlement, or visual layout is replaced.
 */
export function UsCityCarCard({ car, city, priority }: { car: CarCardData; city: string; priority: boolean }) {
  const element = useRef<HTMLDivElement>(null);
  const description = `${car.year} ${car.make} ${car.model} near ${city}`;
  useEffect(() => {
    const photoUrls = new Set([car.primaryImageUrl, car.primaryImageCdnMedium,
      car.primaryImageCdnThumbnail, car.primaryImageCdnFull,
      ...(car.images || []).flatMap(image => [image.url, image.cdnThumbnail, image.cdnMedium, image.cdnFull])]
      .filter((url): url is string => typeof url === "string" && !!url));
    element.current?.querySelectorAll("img").forEach(image => {
      if (photoUrls.has(image.getAttribute("src") || "")) image.alt = description;
    });
  }, [car, description]);
  return <div ref={element} className="contents"><CarCard car={car} priority={priority} measuredImages /></div>;
}
